import { KindResultDecisionCodesEnum } from 'APIPackage/CatalogsModule/enums/KindResultDecisionCodesEnum';

import { IDecisionListItem } from '../interfaces/IDecisionListItem';

const mapKindDecision = {
  [KindResultDecisionCodesEnum.D_1]: 'Предписание',
  [KindResultDecisionCodesEnum.D_2]: 'Незамедлительные меры',
  [KindResultDecisionCodesEnum.D_3]: 'Направление для привлечения к ответственности',
  [KindResultDecisionCodesEnum.D_4]: 'Меры по контролю за устранением',
  [KindResultDecisionCodesEnum.D_5]: 'Предостережение',
  [KindResultDecisionCodesEnum.D_7]: 'Предписание',
  [KindResultDecisionCodesEnum.D_9]: 'Иные решения',
  [KindResultDecisionCodesEnum.D_10]: 'Предписание',
} as const;

export const mapRawToDecision = (raw: IDecisionListItem): IDecisionListItem => {
  return {
    ...raw,
    kindResultDecisionCode: raw.kindResultDecisionCodeList
      ? raw.kindResultDecisionCodeList
          ?.map(item => {
            return mapKindDecision[item as keyof typeof mapKindDecision];
          })
          .toString()
          .split(',')
          .join(', \n\n')
      : '-',

    decisionDate: raw.decisionDateList ? raw.decisionDateList.toString().split(',').join(', \n\n') : '-',
  };
};
